import React, { useMemo, useState } from 'react';

import { RadioOrSelectOption } from '../../../../../types/common.types';
import { Member } from '../../../../../types/entity.types';

import { SHORT_MONTHS } from '../../../../../utils/constants';
import { noOp } from '../../../../../utils/util';

import ProgrammeLayout from '../../../../../layouts/programme/ProgrammeLayout';
import Dropdown from '../../../../common/input/dropdown/Dropdown';
import SupportChatBox from '../support-chat-box/SupportChatBox';
import SupportChatFilter from '../support-chat-filter/SupportChatFilter';
import SupportChatInput from '../support-chat-input/SupportChatInput';

import { ReactComponent as ArrowIcon } from '../../../../../resources/icons/arrow-single.svg';

import './support-chat-new.scss';

type Props = {
  status: string;
  members: Member[];
  username?: string;
  navigateBack: () => void;
  loadSupportChat: (member: RadioOrSelectOption<Member>) => void;
};

const SupportChatNew = ({ status, members, username, navigateBack, loadSupportChat }: Props) => {
  const [filterValue, setFilterValue] = useState('');

  const memberOptions: RadioOrSelectOption<Member>[] = useMemo(
    () =>
      members
        .filter((member) => member.systemUserExternalReference)
        .filter((member) => member.username !== username)
        .filter((member) => !member.emailAddress?.toLowerCase().includes('deleted'))
        .map((member) => ({
          label: `${member.firstName} ${member.lastName} ${member.emailAddress} ${member.username}`,
          value: member.externalReference!,
          ...member
        })),
    [members, username]
  );

  const today = new Date();
  const todayLabel = `${today.getDate()} ${SHORT_MONTHS[today.getMonth()]}`;

  return (
    <ProgrammeLayout>
      <div className="support-chat-new" data-testid={`support-chat-new-${status}`}>
        <div className="support-chat-new__header">
          <div className="support-chat-new__header__icon-container">
            <ArrowIcon onClick={navigateBack} data-testid="arrow-icon" />
          </div>
          <h1>Select Contact:</h1>
          <Dropdown
            options={memberOptions}
            onChange={loadSupportChat}
            renderOption={(option: RadioOrSelectOption<Member>) => (
              <li className="support-chat-new__option">
                <span>
                  {option.firstName} {option.lastName}
                </span>
                <span>{option.emailAddress}</span>
                <span>{option.username}</span>
              </li>
            )}
          />
        </div>
        <SupportChatFilter value={filterValue} onChange={({ target }) => setFilterValue(target.value)} />
        <SupportChatBox messages={[]} emptyDateLabel={todayLabel} />
        <SupportChatInput createMessage={noOp} disabled />
      </div>
    </ProgrammeLayout>
  );
};

export default SupportChatNew;
